import UserActions from "../Types";

const initialState = {
    isRegistering: false,
    registeredSuccess: false,
    newDevice: {},
    isUploading: false,
    uploadSuccess: false,
    uploadedDoc: {},
    isApplying: false,
    applyCardSuccess: false,
    appliedCard: {},
    paymentStatus: false,
    isPaying: false,
    payment: {},
    isGettingCards: false,
    getCardSuccess: false,
    cards: [],
    isGettingTrail: false,
    getUserTrailSuccess: false,
    userTrail: {},
    isGettingApps: false,
    getApplicationsSuccess: false,
    applications: [],
    isRenewingPos: false,
    renewPosSuccess: false,
    renewal: {},
    error: null,
    applicationHashDetails: {},
    isApplicationHashLoaded: false,
    isLoadingAppHash: false,
    isCheckingTerminalStatus: false,
    isResettingTerminal: false,
    terminalStatusResponse: null,
    terminalResetResponse: null,
    isBulkUnlocking: false,
    bulkUnlockResponse: null,
    certificates: [],
    isGettingCertificates: false,
    isGettingViolationReasons: false,
    violationReasons: [],
    
}

export default (state = initialState, action) => {
    switch(action.type){
        case UserActions.REGISTER_DEVICE_START:
            return {
                ...state,
                isRegistering: true,
                registeredSuccess: false,
                error: null
            }
        case UserActions.REGISTER_DEVICE_SUCCESS:
            return {
                ...state,
                isRegistering: false,
                registeredSuccess: true,
                newDevice: action.payload,
                error: null
            }
        case UserActions.REGISTER_DEVICE_FAILURE:
            return {
                ...state,
                isRegistering: false,
                registeredSuccess: false,
                error: action.payload
            }
        case UserActions.RENEW_POS_DOC_START:
            return {
                ...state,
                isRenewingPos: true,
                renewPosSuccess: false,
                error: null
            }
        case UserActions.RENEW_POS_DOC_SUCCESS:
            return {
                ...state,
                isRenewingPos: false,
                renewPosSuccess: true,
                renewal: action.payload,
                error: null
            }
        case UserActions.RENEW_POS_DOC_FAILURE:
            return {
                ...state,
                isRenewingPos: false,
                renewPosSuccess: false,
                error: action.payload
            }
        case UserActions.GET_USER_TRAIL_START:
            return {
                ...state,
                isGettingTrail: true,
                getUserTrailSuccess: false,
                error: null
            }
        case UserActions.GET_USER_TRAIL_SUCCESS:
            return {
                ...state,
                isGettingTrail: false,
                getUserTrailSuccess: true,
                userTrail: action.payload,
                error: null
            }
        case UserActions.GET_USER_TRAIL_FAILURE:
            return {
                ...state,
                isGettingTrail: false,
                getUserTrailSuccess: false,
                error: action.payload
            }
        case UserActions.GET_ALL_APPLICATIONS_START:
            return {
                ...state,
                isGettingApps: true,
                getApplicationsSuccess: false,
                error: null
            }
        case UserActions.GET_ALL_APPLICATIONS_SUCCESS:
            return {
                ...state,
                isGettingApps: false,
                getApplicationsSuccess: true,
                applications: action.payload,
                error: null
            }
        case UserActions.GET_ALL_APPLICATIONS_FAILURE:
            return {
                ...state,
                isGettingApps: false,
                getApplicationsSuccess: false,
                error: action.payload
            }
        case UserActions.PAYMENT_START:
            return {
                ...state,
                isPaying: true,
                paymentStatus: false,
                error: null
            }
        case UserActions.PAYMENT_SUCCESS:
            return {
                ...state,
                isPaying: false,
                paymentStatus: true,
                payment: action.payload,
                error: null
            }
        case UserActions.PAYMENT_FAILURE:
            return {
                ...state,
                isPaying: false,
                paymentStatus: false,
                error: action.payload
            }
        case UserActions.APPLY_FOR_TEST_CARD_START:
            return {
                ...state,
                isApplying: true,
                applyCardSuccess: false,
                error: null
            }
        case UserActions.APPLY_FOR_TEST_CARD_SUCCESS:
            return {
                ...state,
                isApplying: false,
                applyCardSuccess: true,
                appliedCard: action.payload,
                error: null
            }
        case UserActions.APPLY_FOR_TEST_CARD_FAILURE:
            return {
                ...state,
                isApplying: false,
                applyCardSuccess: false,
                error: action.payload
            }
        case UserActions.UPLOAD_POS_DOC_START:
            return {
                ...state,
                isUploading: true,
                uploadSuccess: false,
                error: null
            }
        case UserActions.UPLOAD_POS_DOC_SUCCESS:
            return {
                ...state,
                isUploading: false,
                uploadSuccess: true,
                uploadedDoc: action.payload,
                error: null
            }
        case UserActions.UPLOAD_POS_DOC_FAILURE:
            return {
                ...state,
                isUploading: false,
                uploadSuccess: false,
                error: action.payload
            }
        case UserActions.GET_TEST_CARDS_START:
            return {
                ...state,
                isGettingCards: true,
                getCardSuccess: false,
                error: null
            }
        case UserActions.GET_TEST_CARDS_SUCCESS:
            return {
                ...state,
                isGettingCards: false,
                getCardSuccess: true,
                cards: action.payload,
                error: null
            }
        case UserActions.GET_TEST_CARDS_FAILURE:
            return {
                ...state,
                isGettingCards: false,
                getCardSuccess: false,
                error: action.payload
            }
        case UserActions.CLEAR_POS_STATE:
            return {
                ...state,
                isRegistering: false,
                registeredSuccess: false,
                newDevice: {},
                isUploading: false,
                uploadSuccess: false,
                uploadedDoc: {},
                isApplying: false,
                applyCardSuccess: false,
                appliedCard: {},
                paymentStatus: false,
                isPaying: false,
                payment: {},
                isGettingCards: false,
                getCardSuccess: false,
                cards: [],
                error: null,
                terminalStatusResponse: null,
                terminalResetResponse: null,
                bulkUnlockResponse: null,
                violationReasons: [],

            }
        case UserActions.GET_APPLICATION_HASH_START:
            return {
                ...state,
                isApplicationHashLoaded: false,
                applicationHashDetails: {},
                error: null
            }
        case UserActions.GET_APPLICATION_HASH_SUCCESS:
            return {
                ...state,
                applicationHashDetails: action.payload,
                isApplicationHashLoaded: true,
                error: null
                
            }
        case UserActions.GET_APPLICATION_HASH_FAILURE:
            return {
                ...state,
                isApplicationHashLoaded: false,
                applicationHashDetails: {},
                error: action.payload
            }
        case UserActions.CHECK_TERMINAL_STATUS_START:
            return {
                ...state,
                isCheckingTerminalStatus: true,
                error: null,
                terminalStatusResponse: null,
            }
        case UserActions.CHECK_TERMINAL_STATUS_SUCCESS:
            return {
                ...state,
                isCheckingTerminalStatus: false,
                terminalStatusResponse: action.payload,
                error: null,
            }
        case UserActions.CHECK_TERMINAL_STATUS_FAILURE:
            return {
                ...state,
                isCheckingTerminalStatus: false,
                error: action.payload,
            }
        case UserActions.RESET_TERMINAL_START:
            return {
                ...state,
                isResettingTerminal: true,
                error: null,
                terminalResetResponse: null,
            }
        case UserActions.RESET_TERMINAL_SUCCESS:
            return {
                ...state,
                isResettingTerminal: false,
                terminalResetResponse: action.payload,
                error: null,
            }
        case UserActions.RESET_TERMINAL_FAILURE:
            return {
                ...state,
                isResettingTerminal: false,
                error: action.payload,
            }
        case UserActions.BULK_UNLOCK_TERMINALS_START:
            return { ...state, isBulkUnlocking: true, bulkUnlockResponse: null, error: null }
        case UserActions.BULK_UNLOCK_TERMINALS_SUCCESS:
            // console.log("===== REDUCER BULK UNLOCK SUCCESS =====");
            // console.log("action:", action);
            // console.log("action.payload:", action.payload);
            return { ...state, isBulkUnlocking: false, bulkUnlockResponse: action.payload, error: null }
        case UserActions.BULK_UNLOCK_TERMINALS_FAILURE:
            // console.log("===== REDUCER BULK UNLOCK FAILURE =====");
            // console.log("action:", action);
            return { ...state, isBulkUnlocking: false, error: action.payload }
        case UserActions.GET_CERTIFICATES_START:
            return { ...state, isGettingCertificates: true }
        case UserActions.GET_CERTIFICATES_SUCCESS:
            return { ...state, isGettingCertificates: false, certificates: action.payload || [] }
        case UserActions.GET_CERTIFICATES_FAILURE:
            return { ...state, isGettingCertificates: false }
        case UserActions.CLEAR_BULK_UNLOCK_RESPONSE:
            return {
                ...state,
                bulkUnlockResponse: null, // error: null
            };
        case UserActions.CLEAR_ERROR_RESPONSE: return { ...state, clearErrorResponse: null, error: null }

        case UserActions.GET_VIOLATION_REASONS_START:

            return {
                ...state,
                isGettingViolationReasons: true,
                error: null,
            };

        case UserActions.GET_VIOLATION_REASONS_SUCCESS:

            return {
                ...state,
                isGettingViolationReasons: false,
                violationReasons: action.payload || [],
                error: null,
            };

        case UserActions.GET_VIOLATION_REASONS_FAILURE:

            return {
                ...state,
                isGettingViolationReasons: false,
                violationReasons: [],
                error: action.payload,
            };

        default:
            return state;
    }
}